import validator from "./validator";
import localization from  "./localization"



 class Validation  {
    userIdNumber= (value,validationTexts) => {
        if (!validator.legalTz(value)) {
            return validationTexts.userIdNumber;
        }
        return true;
    };
    required= (value,validationTexts,lang) => {
        if (!value) {
            return localization[lang].required;
        }
        return true;
    };
    dobYear= (value,validationTexts,lang) => {
        if (isNaN(value)) {
            return localization[lang].type.integer;
        }else {
            var d = new Date();
            var currentYear = d.getFullYear();
            if(value<1900 || value > currentYear){
                return this.formatMessage(localization[lang].range,['1900',currentYear]);
            }
        }
        return true;
    };
     dobDay= (value,validationTexts,lang) => {
         if (isNaN(value)) {
             return localization[lang].type.integer;
         }else {
             if(value<1 || value > 31){
                 return this.formatMessage(localization[lang].range,['1','31']);
             }
         }
         return true;
     };
     email= (value,validationTexts,lang) => {
         if (!validator.isEmail(value)) {
             return localization[lang].type.email;
         }
         return true;
     };
    formatMessage = (string, parameters)=>{
        if ('object' === typeof parameters) {
            for (var i in parameters)
                string = this.formatMessage(string, parameters[i]);

            return string;
        }

        return 'string' === typeof string ? string.replace(/%s/i, parameters) : '';
    }
}

const validation = new Validation();
export default validation;
